import React, {
  HTMLAttributes,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import ReactDOM from 'react-dom';

import { Container, Content } from './styles';

type ModalProps = HTMLAttributes<HTMLDivElement> & {
  containerStyle?: React.CSSProperties;
  animated?: boolean;
};

export type ModalHandles = {
  open(): void;
  close(): void;
};

const Modal: React.ForwardRefRenderFunction<any, ModalProps> = (
  { animated = true, children, containerStyle, ...rest },
  ref,
) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpened, setIsOpened] = useState<boolean | undefined>(undefined);

  const open = useCallback(() => {
    setIsOpened(true);
  }, []);

  const close = useCallback(() => {
    setIsOpened(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  useEffect(() => {
    if (isOpened) {
      setIsVisible(true);
    } else {
      setTimeout(() => {
        setIsVisible(false);
      }, 300);
    }
  }, [isOpened]);

  return ReactDOM.createPortal(
    <Container
      className={isOpened ? 'visible' : 'hidden'}
      animated={animated}
      style={{
        ...containerStyle,
        opacity: typeof isOpened === 'undefined' ? 0 : 1,
        display: isVisible ? 'flex' : 'none',
      }}
    >
      <Content {...rest}>{children}</Content>
    </Container>,
    document.body,
  );
};

export default React.forwardRef(Modal);
